function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import { onResize, onScroll } from "../../../../wdh-foundation/wdh";
var ReactHOC = function ReactHOC(Component) {
  var HOC = /*#__PURE__*/function (_React$Component) {
    function HOC(props) {
      var _this;
      _classCallCheck(this, HOC);
      _this = _callSuper(this, HOC, [props]);
      _this.state = {
        isDesktop: HOC.resolveDesktop(),
        isTablet: HOC.resolveTablet(),
        isScrolled: HOC.resolveIfPageIsScrolled(),
        pageScrollOffset: window.pageYOffset
      };
      return _this;
    }
    _inherits(HOC, _React$Component);
    return _createClass(HOC, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;
        onResize(function () {
          _this2.updateDesktopState();
          _this2.updateTabletState();
        });
        onScroll(function () {
          _this2.updateScrollState();
          _this2.updateIfPageIsScrolled();
        });
      }
    }, {
      key: "updateDesktopState",
      value: function updateDesktopState() {
        this.setState({
          isDesktop: HOC.resolveDesktop()
        });
      }
    }, {
      key: "updateTabletState",
      value: function updateTabletState() {
        this.setState({
          isTablet: HOC.resolveTablet()
        });
      }
    }, {
      key: "updateScrollState",
      value: function updateScrollState() {
        this.setState({
          pageScrollOffset: window.pageYOffset
        });
      }
    }, {
      key: "updateIfPageIsScrolled",
      value: function updateIfPageIsScrolled() {
        if (window.pageYOffset > 0) {
          this.setState({
            isScrolled: true
          });
        } else {
          this.setState({
            isScrolled: false
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(Component, _extends({}, this.props, this.state));
      }
    }], [{
      key: "resolveDesktop",
      value: function resolveDesktop() {
        return window.matchMedia('(min-width:992px)').matches;
      }
    }, {
      key: "resolveTablet",
      value: function resolveTablet() {
        return window.matchMedia('(min-width:768px)').matches;
      }
    }, {
      key: "resolveIfPageIsScrolled",
      value: function resolveIfPageIsScrolled() {
        return window.pageYOffset > 0;
      }
    }]);
  }(React.Component);
  return HOC;
};
export default ReactHOC;